// React imports
import { ReactElement, ReactNode } from "react";

// Mui imports
import { Button, SvgIconProps } from "@mui/material";
import { styled } from "@mui/system";

// React router imports
import { Link } from "react-router-dom";

// Styling for the button
const StyledButton = styled(Button)(({ theme }) => ({
  padding: "5px 30px",

  // Pointing at the color specified in the the AppTheme
  // backgroundColor: theme.palette.primary.main,
  color: "#686565",
  border: "1px solid #686565",
}));

// Component props
export interface IProps {
  onClick?:
    | ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  variant?: "text" | "outlined" | "contained" | undefined;
  startIcon?: ReactElement<SvgIconProps>;
  endIcon?: ReactElement<SvgIconProps>;
  to?: string;
  disabled?: boolean;
  disableElevation?: boolean;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning";
  style?: any;
  size?: "small" | "medium" | "large";
  children?: ReactNode;
}

export default function AppPrimaryButton({
  onClick,
  startIcon,
  endIcon,
  to,
  disabled,
  // Setting the default type if parameter is not passed in
  variant = "outlined",
  children,
  // Setting the default value
  disableElevation = true,
  color,

  size,
  style,
}: IProps) {
  return (
    <StyledButton
      onClick={onClick}
      // @ts-ignore
      to={to}
      // If a location is passed in the button turns into a react router link
      component={to ? Link : "button"}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      style={style}
      disableElevation={disableElevation}
      variant={variant}
      size={size}
      color={color}
    >
      {children}
    </StyledButton>
  );
}
